import { getGridStringOperators } from "@mui/x-data-grid-pro";
import React from "react";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { formatCurrency } from "@poseidon/utils/currency";
import { getDate } from "@poseidon/firebase/timestamp";
import { timestampColumn } from "../../DataGrid/ColumnHelpers";
import { Chip } from "@mui/material";
import PendingIcon from "@mui/icons-material/Pending";
import SailingIcon from "@mui/icons-material/Sailing";
import DangerousIcon from "@mui/icons-material/Dangerous";
import WarningIcon from "@mui/icons-material/Warning";
import { camelToSentenceCase } from "@poseidon/utils/text";
import { RateTypeChip, rateTypeLabel } from "../components/RateTypeChip";

export const getColumnDefinition = () => [
  {
    field: "id",
    headerName: "ID",
    width: 180,
    filterOperators,
  },
  {
    field: "agreementNumber",
    headerName: "Agreement Number",
    width: 160,
    filterOperators,
    hideable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    filterOperators,
    valueGetter: ({ value, row }) => {
      if (!row.remainingPayments && value === "active") {
        return "closing";
      }
      return value;
    },
    renderCell: ({ value }) => {
      if (value === "pending") {
        return <Chip icon={<PendingIcon />} label="Pending" />;
      }
      if (value === "active") {
        return <Chip color="primary" icon={<SailingIcon />} label="Active" />;
      }

      return (
        <Chip
          color="error"
          icon={<DangerousIcon />}
          label={camelToSentenceCase(value ?? "Invalid")}
        />
      );
    },
  },
  {
    field: "rateType",
    headerName: "Rate Type",
    width: 150,
    filterOperators,
    valueGetter: ({ row }) => rateTypeLabel(row.parameters?.fixedRate),
    renderCell: ({ row }) => (
      <RateTypeChip fixedRate={row.parameters?.fixedRate} />
    ),
  },
  {
    field: "bankFunder",
    headerName: "Bank Funder",
    width: 160,
    filterOperators,
  },
  {
    field: "blockNumber",
    headerName: "Block #",
    width: 90,
    filterOperators,
  },
  timestampColumn({
    field: "agreementCreation",
    headerName: "Created At",
  }),
  {
    field: "arrears",
    headerName: "Arrears",
    width: 320,
    filterOperators,
    renderCell: ({ row }) => {
      if (!row.duePayments) {
        return "";
      }
      return (
        <>
          <WarningIcon color="warning" sx={{ mr: 1 }} />
          {`${formatCurrency(row.arrears)} (${row.duePayments} payment${
            row.duePayments > 1 ? "s" : ""
          } - Due ${getDate(row.dateOfOldestDuePayment).toLocaleDateString(
            "en-GB"
          )})`}
        </>
      );
    },
  },
  {
    field: "capitalBalance",
    headerName: "Capital Balance",
    width: 210,
    filterOperators,
    renderCell: ({ row }) => {
      if (!row.schedule) {
        return "N/A";
      }
      if (row.capitalBalance === 0) {
        return "£0";
      }
      return `${formatCurrency(row.capitalBalance)} (${
        row.remainingPayments
      } payment${row.remainingPayments > 1 ? "s" : ""})`;
    },
  },
  {
    field: "sailor",
    headerName: "Sailor",
    width: 210,
    filterOperators,
    renderCell: ({ row }) => {
      return (
        <WithDoc
          docRef={row.sailors?.at(0)}
          Component={({ data: sailor }) =>
            `${sailor.firstName} ${sailor.lastName}`
          }
        />
      );
    },
  },
];

const filterOperators = getGridStringOperators().filter(
  (operator) => operator.value === "equals"
);
